import {
    ADD_PERIPHERAL,
    ADD_PRODUCT,
    ADMINISTRATION_ACTION_SELECTED,
    ADMINISTRATION_MENU_OPENED,
    API,
    BAG_PROMPT_ANSWERED,
    CANCEL_TRANSACTION,
    CHANGE_MODE,
    CHANGE_TRANSACTION_MODE,
    CREATE_ACCOUNT_CLICKED,
    CREATE_ACCOUNT_FAILED,
    CREATE_ACCOUNT_OPENED,
    CREATE_ACCOUNT_SUBMITTED,
    CUSTOMER_API,
    CUSTOMER_SEARCH_OPENED,
    OPEN_MODAL,
    PAYMENT_TYPE_SELECTED, PRODUCT_LIST_MOUNTED,
    RECEIPT_CHOICE_MADE,
    RECEIPT_DELIVERED,
    RETURN_RECEIPT_SUBMITTED,
    SCANNER_DETECTED_LOYALTY_CARD,
    SET_DEFAULT_CUSTOMER,
    SET_LOADING,
    SET_PRODUCT_SELECT_LIST,
    SHOW_DIALOGUE,
    SHOW_RIGHT_PANEL_DIALOGUE,
    UPDATE_PERIPHERAL,
    UPDATE_PRODUCTS,
    VERIFIED_RETURN_OPENED,
    VERIFIED_RETURN_SUBMITTED
} from "../../actionTypes";
import {getNumberOfArticles, getProductsTotalSum} from "../../selectors";
import {track as amplitudeTrack} from "@amplitude/analytics-browser";
import {ADD_PAYMENT} from "../../payment/actionTypes";
import Decimal from "decimal.js";

export const track = (event, parameters, state) => {
    console.log("Amplitude:", {event, parameters});
    amplitudeTrack(event, parameters);
}

let lastProductSearchTerm = "";
let lastAddedProduct;
let transactionStage = "scan";
const middleware = store => next => action => {
    next(action);
    const state = store.getState();

    if(action.type === PRODUCT_LIST_MOUNTED){
        track("basket_viewed", {
            article_count: getNumberOfArticles(state.rootReducer.productsInBasket),
            store_id: state.rootReducer.warehouse.code,
            staff_id: state.rootReducer.user.employeeID,
            country: state.rootReducer.erplyConf.DKTCountryCode,
            device_type: state.rootReducer.cashierMode ? 'EPOS' : 'SCO'
        });
    }

    if((window.AppConf?.amplitude?.enabled ?? false) === false){
        return;
    }

    switch (action.type) {
        case UPDATE_PRODUCTS: {
            track(state.rootReducer.mode === "payment" ? "payment_screen_viewed" : "basket_viewed", {
                article_count: getNumberOfArticles(state.rootReducer.productsInBasket),
                basket_total: getProductsTotalSum(state.rootReducer.productsInBasket)
            });
            if(typeof lastAddedProduct !== "undefined"){
                let lastProductInBasket = state.rootReducer.productsInBasket[state.rootReducer.productsInBasket.length - 1];
                track("product_added_to_basket", {
                    item_code: lastAddedProduct.data.code,
                    item_name: lastAddedProduct.name,
                    item_price: lastProductInBasket.netPrice,
                    add_method: lastAddedProduct.addMethod
                });
                lastAddedProduct = undefined;
            }
            break;
        }
        case SHOW_RIGHT_PANEL_DIALOGUE: {
            if(action.payload.id === "productSearch"){
                track("product_search_opened", {
                    trigger_source: "header_icon",
                });
            }else if(action.payload.id === "enterPromoCode"){
                track("promo_code_opened");
            }
            break;
        }
        case OPEN_MODAL: {
            if(action.payload.id === "productSearchModal"){
                track("product_search_opened", {
                    trigger_source: "rfid_fallback",
                });
            }
            break;
        }
        case API: {
            if( action?.payload?.data?.request === "getProducts" &&
                typeof action?.payload?.data?.searchNameIncrementally !== "undefined"
            ){
                lastProductSearchTerm = action.payload.data.searchNameIncrementally;
            }
            break;
        }
        case SET_PRODUCT_SELECT_LIST: {
            if(lastProductSearchTerm !== ""){
                track("product_search_performed", {
                    search_term: lastProductSearchTerm,
                    result_count: action.payload.length,
                    search_type: "keyword"
                });
                lastProductSearchTerm = "";
            }
            break;
        }
        case ADD_PRODUCT: {
            lastAddedProduct = {...action.payload};
            if(state.rootReducer.productSelectList.length > 0 || state.rootReducer?.rightPanelDialogue?.id === "productSearch"){
                lastAddedProduct.addMethod = 'search';
            }else{
                lastAddedProduct.addMethod = typeof lastAddedProduct.data.RFIDTag !== "undefined" ? 'rfid' : 'scan';
            }
            break;
        }
        case SCANNER_DETECTED_LOYALTY_CARD: {
            track("loyalty_card_scanned", {
                scan_method: "barcode"
            });
            break;
        }
        case CREATE_ACCOUNT_CLICKED: {
            track("loyalty_signup_clicked");
            break;
        }
        case SET_DEFAULT_CUSTOMER: {
            track("loyalty_prompt_skipped");
            break;
        }
        case CREATE_ACCOUNT_OPENED: {
            track("loyalty_lookup_opened", {
                lookup_type: "new_member"
            });
            break;
        }
        case CREATE_ACCOUNT_SUBMITTED: {
            track("loyalty_signup_submitted", {
                has_firstname: typeof action.payload.claims.given_name !== "undefined",
                has_lastname: typeof action.payload.claims.family_name !== "undefined",
                has_email: typeof action.payload.claims.email !== "undefined",
                toc_accepted: action.payload.customerConsentSet
            });
            break;
        }
        case CREATE_ACCOUNT_FAILED: {
            track("loyalty_signup_failed", {
                error_message: action.payload.message
            });
            break;
        }
        case CUSTOMER_SEARCH_OPENED: {
            track("loyalty_lookup_opened", {
                lookup_type: "existing_member"
            });
            break;
        }
        case CUSTOMER_API: {
            if(action.payload.request === "getCustomer"){
                let lookupMethod = "card_number";
                if(typeof action.payload.data.email !== "undefined"){
                    lookupMethod = "email";
                }else if(typeof action.payload.data.mobile !== "undefined"){
                    lookupMethod = "phone";
                }
                track("loyalty_lookup_submitted", {
                    lookup_method: lookupMethod
                });
            }

            break;
        }
        case CHANGE_MODE: {
            if(action.payload.mode === "payment"){
                track("payment_screen_viewed", {
                    article_count: getNumberOfArticles(state.rootReducer.productsInBasket),
                    basket_total: getProductsTotalSum(state.rootReducer.productsInBasket)
                });
            }else if(action.payload.mode === "done"){
                track("receipt_choice_viewed", {
                    countdown_seconds_shown: window.AppConf.receiptTimeout || 10
                });
            }
            break;
        }
        case BAG_PROMPT_ANSWERED: {
            track("bag_prompt_answered", {
                bag_requested: action.payload
            });
            break;
        }
        case PAYMENT_TYPE_SELECTED: {
            track("payment_method_selected", {
                payment_method: action.payload
            });
            break;
        }
        case ADD_PAYMENT: {
            if(action.payload.type === "CASH"){
                let payment_balance = (new Decimal(state.payment.totalSum)).minus(new Decimal(state.payment.totalPaid)).toDecimalPlaces(2).toNumber();
                track("payment_cash_confirmed", {
                    cash_entered: action.payload.cashPaid,
                    balance_to_pay: action.payload.cashChange === 0 ? payment_balance : (action.payload.cashChange * -1),
                    used_100pct_shortcut: action.payload?.fullButtonUsed ?? false
                });
            }
            break;
        }
        case RECEIPT_CHOICE_MADE: {
            if(action.payload === "declined"){
                track("receipt_declined", {
                    dismissed_by: "button"
                });
            }else if(action.payload === "timeout"){
                track("receipt_declined", {
                    dismissed_by: "timeout"
                });
            }else{
                track("receipt_method_selected", {
                    receipt_method: action.payload
                });
            }
            break;
        }
        case RECEIPT_DELIVERED: {
            if(action.payload.deliveryType === "email"){
                track("receipt_email_submitted");
            }
            break;
        }
        case CHANGE_TRANSACTION_MODE: {
            if(action.payload === "RETURN"){
                track("return_initiated", {
                    trigger_source: action.triggerSource
                });
            }
            break;
        }
        case SHOW_DIALOGUE: {
            if(action.payload.id === "unverifiedReturn"){
                track("return_type_selected", {
                    return_type: "unverified"
                });
            }
            break;
        }
        case RETURN_RECEIPT_SUBMITTED: {
            track("return_receipt_submitted", {
                receipt_number_length: action.payload.referenceReceiptNumber !== "" ?
                    action.payload.referenceReceiptNumber.length : action.payload.action.payload.webOrderNumber.length
            });
            break;
        }
        case VERIFIED_RETURN_OPENED: {
            track("return_type_selected", {
                return_type: "verified"
            });
            break;
        }
        case VERIFIED_RETURN_SUBMITTED: {
            track("return_items_confirmed", {
                items_selected_count: action.payload.itemsSelectedCount,
                items_total_count: action.payload.itemsTotalCount,
                return_value: action.payload.itemsSelectedValue
            });
            break;
        }
        case ADMINISTRATION_MENU_OPENED: {
            track("admin_menu_opened", {
                staff_id: action.payload.employeeID,
                store_id: state.rootReducer.warehouse.code
            });
            break;
        }
        case ADMINISTRATION_ACTION_SELECTED: {
            track("admin_action_selected", {
                action: action.payload
            });
            break;
        }
        case CANCEL_TRANSACTION: {
            track("cancel_transaction", {
                stage: state.rootReducer.mode
            });
            break;
        }
        case SET_LOADING: {
            if(state.rootReducer.loaderCount === 0){
                track("loading_animation_end");
            }else if(state.rootReducer.loaderCount === 1 && action.payload){
                track("loading_animation_start");
            }
            break;
        }
        case ADD_PERIPHERAL: {
            if(action.payload.name === "epsi"){
                break;
            }
            track("device_pairing_started", {
                device_type: action.payload.name
            });
            break;
        }
        case UPDATE_PERIPHERAL: {
            if(action.payload.name === "epsi"){
                break;
            }
            track("device_pairing_finished", {
                device_type: action.payload.name,
                status: action.payload.status
            });
            break;
        }
        default: {}
    }
}

export default middleware;